<template>
<div>
    <section>
        <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 xs:w-1/1 w-full">
                <p>Seleccionar libro</p>
                <v-select class="mb-4 w-full" v-model="libroSelect" :options="arregloLibros" :reduce="arregloLibros => arregloLibros" label="nombrelibro" @input="unidadSelect='';cargaUnidades()" />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 xs:w-1/1 w-full">
                <p>Seleccionar unidad</p>
                <v-select class="mb-4 w-full" v-model="unidadSelect" :options="arregloUnidades" label="nombre" :reduce="arregloUnidades => arregloUnidades" @input="f_unidadesOk()" />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 xs:w-1/1 w-full">
                <p>Seleccionar tipo de evaluación</p>
                <v-select class="mb-4 w-full" :disabled="editar.idpregunta ? true : false" v-model="tipoSelect" :options="arregloTipos" :reduce="arregloTipos => arregloTipos" label="nombre" @input="f_select_tipos()" />
            </div>
        </div>
    </section>
    <!--menu-->
    <div class="flex justify-center" v-if="tipoSelect.id">
        <vs-button type="line" color="#286ECE" class="m-3" icon-pack="feather" icon="icon-help-circle" @click="menu =0;">Pregunta</vs-button>
        <vs-button type="line" v-if="tipoSelect.id !== 7" color="#3FCE28" class="m-2" icon-pack="feather" icon="icon-file-text" @click="menu =1;">Opciones</vs-button>
    </div>
    <!--componentes-->
    <div>
        <div v-if="menu == 0">
            <div v-if="tipoSelect.id">
                <crear_preguntaVue :editar="editar" :editOk="editOk" :libroSelect="libroSelect" :unidadSelect="unidadSelect" :tipoSelect="tipoSelect" :cabecera="cabecera" :tipos="tipos" :unidadOk="Boolean(unidadOk)" :tipoOk="Boolean(tipoOk)" @change_pregunta_editada="change_pregunta_editada" />
            </div>
            <br><br><br><br><br><br><br><br><br>
        </div>
        <div v-if="menu == 1">
            <div v-if="datos.id > 0">
                <ScreenOpciones v-if="tipoSelect.id !== 5" :tipoSelect="tipoSelect" :datos="datos" @change_pregunta_editada="change_pregunta_editada" />
                <ScreenOpciones v-if="tipoSelect.id == 5" tipo="5" :datos="datos" @change_pregunta_editada="change_pregunta_editada" />
            </div>
            <div v-else>
                <vs-alert color="warning" title="Advertencia">
                    <p class="text-center">Guarde primero la <b>pregunta</b> para crear opciones</p>
                </vs-alert>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import GeneralMixin from '@/mixins/GeneralMixin'
import vSelect from 'vue-select'
const crear_preguntaVue = () => import('../crear_pregunta.vue');
const ScreenOpciones = () => import('./Opciones/ScreenOpciones.vue')
export default {
    components: {
        crear_preguntaVue,
        ScreenOpciones,
        vSelect,
    },
    mixins: [GeneralMixin],
    data() {
        return {
            menu: 0,
            datos: '',
            arregloLibros: [],
            unidades: [],
            arregloUnidades: [],
            arregloTipos: [],
            libroSelect: '',
            unidadSelect: '',
            tipoSelect: '',
            propiedades: {},
            cabecera: {
                libroSelect: '',
                unidadSelect: '',
                puntaje: '',
                estado: '',
            },
            tipos: {
                tp1: false,
                tp2: false,
                tp3: false,
                tp4: false,
                tp5: false,
                tp6: false,
                tp7:false,
                tp8:false,
            },
            unidadOk: false,
            tipoOk: false,
            color_alert: '',
            usuario: '',
        }
    },
    props: {
        editar: {
            type: Object,
            default: () => {}
        },
        editOk: {
            type: Boolean
        },
        libroListado: {
            type: Object,
            default: () => {}
        },
        arrayLibrosDocente: {
            type: Array,
            default: () => []
        },
    },
    watch: {
        editar(results) {
            let me = this;
            if (results.idpregunta > 0) {
                me.iniciar(me.editar)
            }
        },
        editOk(results) {
            let me = this;
            if (results) {
                me.iniciar(me.editar)
            }
        },
        'tipoSelect.id': function (results) {
            let me = this;
        }
    },
    mounted() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
        // console.log('me.usuario screen crear pregunta',me.usuario)
        if (me.editar.idpregunta > 0) {
            me.iniciar(me.editar)
        }
        if (me.libroListado.idlibro) {
            me.libroSelect = me.libroListado
            me.cargaUnidades()
        }
        // console.log('usuario dddddddd',me.usuario)
        if (me.usuario.id_group == 6) {
            me.arregloLibros = this.arrayLibrosDocente;
        } else {
            me.getLibros();
        }
        me.f_get_Tipos();
    },
    methods: {
        getLibros() {
            let me = this;
            me.$vs.loading();
            this.$http.get(this.$server_url + 'libro_enUnidad')
                .then(res => {
                    me.arregloLibros = res.data;
                    me.$vs.loading.close();
                })
                .catch(error => {
                    console.log(error)
                    me.$vs.loading.close();

                })
        },
        cargaUnidades() {
            let me = this;
            me.unidades = []
            me.arregloUnidades = []
            // me.unidadSelect = ''
            if (me.libroSelect.idlibro == "" || me.libroSelect.idlibro == null || me.libroSelect.idlibro == undefined) {
                me.unidadSelect = ''
                me.libroSelect.idlibro = ''
                return
            }
            me.$vs.loading();
            this.$http.get(this.$server_url + 'unidadesX_Libro/' + me.libroSelect.idlibro)
                .then(res => {
                    // console.log(res.data)
                    let datos = res.data
                    if (datos.length > 0) {
                        datos.forEach(element => {
                            var cal = new Object();
                            cal.id = element.id_unidad_libro
                            cal.nombre = element.unidadCompleta
                            me.arregloUnidades.push(cal)
                        })
                    }
                    me.$vs.loading.close();
                })
                .catch(error => {
                    console.log(error)
                    me.$vs.loading.close();
                })
        },
        f_get_Tipos() {
            let me = this;
            this.$http.get(me.$server_url + 'tipo_evaluacion_activa')
                .then(res => {
                    me.arregloTipos = res.data;
                })
                .catch(err => {
                    me.propiedades.mensaje = err;
                    me.f_notificaciones(me.propiedades.mensaje, "danger", "alert-triangle");
                })
        },
        f_unidadesOk() {
            let me = this;
            if (me.unidadSelect == null || me.unidadSelect == undefined) {
                me.propiedades.mensaje = "Seleccione una unidad";
                me.f_notificaciones(me.propiedades.mensaje, "warning");
                me.unidadOk = false;
                return;
            }
            me.unidadOk = true;
            me.f_rellenar_cabecera();
        },
        f_rellenar_cabecera() {
            let me = this;
            me.cabecera = {
                libroSelect: me.libroSelect.idlibro,
                unidadSelect: me.unidadSelect.id,
                tipo: me.tipoSelect.id,
                usuario: me.usuario.idusuario,
                id_grupo: me.usuario.id_group
            }
            // console.log('cabecera',me.cabecera);
        },
        iniciar(item) {
            let me = this;
            let getId = 0
            if (item.idpregunta) {
                getId = item.idpregunta
            } else {
                getId = item.id
            }
            me.datos = {
                id: getId,
                pregunta: item.pregunta,
                puntaje: item.puntaje,
                estado: item.estado,
                columna1: item.columna1,
                columna2: item.columna2,
                uso_evaluacion: item.uso_evaluacion,
                uso_repaso: item.uso_repaso,
            }
            me.libroSelect = {
                idlibro: this.editar.id_libro,
                nombrelibro: this.editar.nombrelibro
            }
            me.unidadSelect = {
                id: this.editar.id_unidad_libro,
                nombre: this.editar.nombre_unidad
            }
            me.tipoSelect = {
                id: this.editar.id_tipo,
                nombre: this.editar.nombre
            }
            me.f_select_tipos();
            me.f_unidadesOk();
        },
        f_select_tipos() {
            let me = this;
            me.f_cambiar_tipos_opciones();
            if (me.tipoSelect == null) {
                return
            }
            me.f_rellenar_cabecera();
            switch (me.tipoSelect.id) {
                case 1:
                    me.tipos.tp1 = true;
                    me.tipoOk = true;
                    me.color_alert = 'rgb(140, 11, 11)'
                    break;
                case 2:
                    me.tipos.tp2 = true;
                    me.tipoOk = true;
                    me.color_alert = 'rgb(140, 11, 136)'
                    break;
                case 3:
                    me.tipos.tp3 = true;
                    me.tipoOk = true;
                    me.color_alert = 'rgb(48, 11, 140)'
                    break;
                case 4:
                    me.tipos.tp4 = true;
                    me.tipoOk = true;
                    me.color_alert = 'rgb(11, 125, 140)'
                    break;
                case 5:
                    me.tipos.tp5 = true;
                    me.tipoOk = true;
                    me.color_alert = 'rgb(28, 140, 11)'
                    break;
                case 6:
                    // me.tipos.tp6 = true;
                    // me.tipoOk = true;
                    me.color_alert = 'rgb(136, 140, 11)'
                    break;
                case 7:
                    me.tipos.tp7 = true;
                    me.tipoOk = true;
                    me.color_alert = 'rgb(140, 48, 11)'
                    break;
                case 8:
                    me.tipos.tp8 = true;
                    me.tipoOk = true;
                    me.color_alert = 'rgb(140, 48, 11)'
                    break;
                default:
                    me.f_cambiar_tipos_opciones();
                    break;
            }
        },
        f_cambiar_tipos_opciones() {
            let me = this;
            me.tipoOk = false;
            me.tipos = {
                tp1: false,
                tp2: false,
                tp3: false,
                tp4: false,
                tp5: false,
                tp6: false,
            }
        },
        change_pregunta_editada(e) {
            this.$emit('change_pregunta_editada', e)
            // console.log('screen crear pregunta.vue - 324')
        }
    }
}
</script>
